import { createUseStyles } from 'react-jss'
import { colors } from 'components/common'

const useSoundsSelectModalStyles = createUseStyles({
  selectedSoundsWrapper: {
    marginBottom: '1rem',

    '& > *': {
      marginRight: '1rem'
    }
  },

  selectedSoundBadge: {
    backgroundColor: '#fff',
    borderRadius: '4px',
    overflow: 'hidden',
    boxShadow: '0px 0 10px -1px rgba(0,0,0,0.08)',

    '& > .selected-filename': {
      padding: '5px 10px'
    },

    '& > i': {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: colors.red50,
      color: colors.red500,
      padding: '5px',
      cursor: 'pointer',
      transition: 'none',

      '&:hover': {
        backgroundColor: colors.red500,
        color: '#fff'
      }
    }
  }
})

export { useSoundsSelectModalStyles }
